import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import s from './Map.module.scss';

const Map = ({ foo }) => <div className={classNames(s.foo)}>{foo}</div>;

Map.propTypes = { foo: PropTypes.string };

Map.defaultProps = { foo: 'I am Map' };

export default Map;
